import type { TTripTaskRes } from 'api/swagger';
import { ETripTaskType } from 'types/trips';

export const NON_ATTACHABLE_TASK_TYPES: TTripTaskRes['type'][] = [
  ETripTaskType.trailer_swap,
  ETripTaskType.return_asset,
];
